module.exports = __webpack_public_path__ + "img/PrivInvestSupperYacht-background.6b20c41e.jpg";